import { useContext } from 'react';
import { DialogContext } from '../../components/ConfirmDialogProvider/ConfirmDialogProvider';

export const useConfirmDialog = () => {
  const context = useContext(DialogContext);
  if (context.confirm === undefined) {
    throw new Error(
      'useConfirmDialog must be used within a ConfirmDialogProvider'
    );
  }

  return {
    confirm: context.confirm,
  };
};
